import * as Yup from 'yup';

import i18n from '@/i18n';

export const createCeremonyTemplateScheme = Yup.object().shape({
  name: Yup.string().required(i18n.t('ceremonyTemplateNameRequired', { ns: 'common' })),
  slots: Yup.array().min(1, i18n.t('slotsMinimumRequired', { ns: 'common' })),
  organizationId: Yup.number()
    .required(i18n.t('organizationRequired', { ns: 'common' }))
    .moreThan(0, i18n.t('organizationRequired', { ns: 'common' }))
});

export const updateCeremonyTemplateScheme = Yup.object().shape({
  name: Yup.string().required(i18n.t('ceremonyTemplateNameRequired', { ns: 'common' })),
  slots: Yup.array().min(1, i18n.t('slotsMinimumRequired', { ns: 'common' }))
});
